export class DeleteFleetUserRequest {
    customerId?: string;
    userEmail?: string;
    fleetKind?: string;
}